import BaseService from "../../BaseService";

const { http, axios, buildHeaders, buildEndpoint } = BaseService();

export function UploadAvatar(postdata) {
  var headers = buildHeaders();
  var endpoint = buildEndpoint("files/uploadAvatar");
  return axios.post(endpoint, postdata, {
    headers: headers,
  });
}

export function UploadAvatarUser(postdata) {
  var headers = buildHeaders();
  var endpoint = buildEndpoint("files/uploadAvatarUser");
  return axios.post(endpoint, postdata, {
    headers: headers,
  });
}

export function Upload(postdata) {
  var headers = buildHeaders();
  var endpoint = buildEndpoint("files/upload");
  return axios.post(endpoint, postdata, {
    headers: headers,
  });
}

export function GetListFile(id) {
  return http({
    url: "files/get-list-files-by-id/" + id,
    method: "get",
  });
}

export function DeleteListFile(postdata) {
  const data = [...postdata];
  return http({
    url: "Files/delete-list-files",
    method: "post",
    data,
  });
}

export function ResetAvatarUser(id) {
  return http({
    url: "Users/reset-avatar/" + id,
    method: "get",
  });
}

export function FileHuongDan(postdata) {
  const data = { ...postdata };
  return http({
    url: "files/get-list-file-huong-dan?codefile=HUONGDAN",
    method: "get",
    data,
  });
}

export function DeleteFileHuongDan(postdata) {
  const data = [...postdata];
  return http({
    url: "files/deletehuongdan/" + postdata,
    method: "get",
    data,
  });
}

///////////////////////////////////////////
